export const speakerStarSpawner = () => {
    const starSrc = "./assets/images/speaker-star.svg";
    const container = document.querySelector(".speaker__container");

    if (!container) return;

    // Create a layer for the stars inside the speaker container
    const starLayer = document.createElement("div");
    Object.assign(starLayer.style, {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: "5", // Above background, below interactive elements if needed, or adjust
        overflow: "hidden",
        borderRadius: "2rem" // Match container radius
    });
    container.appendChild(starLayer);

    const activeStars = [];
    const maxStars = 6; // Increased to 6 stars
    let isVisible = false;

    // Observer to handle visibility
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            isVisible = entry.isIntersecting;
            if (isVisible) {
                // Restart logic if needed: fill up to maxStars
                const currentCount = activeStars.length;
                const needed = maxStars - currentCount;
                for (let i = 0; i < needed; i++) {
                    scheduleSpawn();
                }
            }
        });
    }, { threshold: 0 }); // Trigger as soon as visible

    observer.observe(container);

    function createStar() {
        if (!document.contains(container)) return; // Safety check

        const star = document.createElement("img");
        star.src = starSrc;
        star.alt = "";

        // Get exclusion zones (speaker items and brains)
        // We do this every time or cache it? caching is better but layout might shift?
        // Let's get fresh rects to be safe against layout changes/loading
        const exclusionElements = container.querySelectorAll('.speaker__item, .speakerbrain img, .speakerbrain');
        const containerRect = container.getBoundingClientRect();

        let x, y;
        let safePositionFound = false;
        const maxAttempts = 15; // Increased attempts

        for (let i = 0; i < maxAttempts; i++) {
            // Random position within the container (0-100%)
            const randX = Math.random() * 100;
            const randY = Math.random() * 100;

            // Convert to pixels relative to viewport to compare with exclusion rects
            const testX = containerRect.left + (randX / 100) * containerRect.width;
            const testY = containerRect.top + (randY / 100) * containerRect.height;

            // Check collision with all excluded elements
            let collision = false;
            for (const el of exclusionElements) {
                const rect = el.getBoundingClientRect();
                // Simple point-in-rect check
                // Expanding the rect slightly can help avoid "touching" elements (padding)
                const padding = 10;
                if (
                    testX >= rect.left - padding &&
                    testX <= rect.right + padding &&
                    testY >= rect.top - padding &&
                    testY <= rect.bottom + padding
                ) {
                    collision = true;
                    break;
                }
            }

            if (!collision) {
                x = randX;
                y = randY;
                safePositionFound = true;
                break;
            }
        }

        // If we couldn't find a safe spot after maxAttempts, skip spawning this star
        if (!safePositionFound) return;

        const isMobile = window.innerWidth < 768;
        const baseSize = isMobile ? 3 : 6;
        const size = baseSize * (0.8 + Math.random() * 0.4) + "rem"; // Random variation

        Object.assign(star.style, {
            position: "absolute",
            left: `${x}%`,
            top: `${y}%`,
            width: size,
            height: "auto",
            opacity: "0",
            transform: "translate(-50%, -50%) scale(0)",
            willChange: "transform, opacity, width" // optimize
        });

        starLayer.appendChild(star);

        // Increased duration to keep them visible longer
        const duration = Math.random() * 1500 + 3000; // 3-4.5s duration

        const animation = star.animate(
            [
                { opacity: 0, transform: "translate(-50%, -50%) scale(0.5)", offset: 0 },
                { opacity: 1, transform: "translate(-50%, -50%) scale(1)", offset: 0.15 }, // Fade in faster
                { opacity: 0.7, transform: "translate(-50%, -50%) scale(0.9)", offset: 0.5 }, // Don't fade out completely
                { opacity: 1, transform: "translate(-50%, -50%) scale(1)", offset: 0.85 }, // Stay visible longer
                { opacity: 0, transform: "translate(-50%, -50%) scale(0.5)", offset: 1 }
            ],
            {
                duration: duration,
                easing: "cubic-bezier(0.25, 0.1, 0.25, 1)",
                fill: "forwards"
            }
        );

        const starId = Date.now() + Math.random();
        activeStars.push({ id: starId });

        animation.onfinish = () => {
            star.remove();
            const index = activeStars.findIndex(s => s.id === starId);
            if (index > -1) activeStars.splice(index, 1);
            scheduleSpawn();
        };
    }

    function scheduleSpawn() {
        // Stop spawning if not visible
        if (!isVisible) return;

        if (document.hidden) {
            setTimeout(scheduleSpawn, 1000);
            return;
        }

        if (activeStars.length < maxStars) {
            setTimeout(() => {
                attemptSpawn();
            }, Math.random() * 1000 + 200);
        }
    }

    function attemptSpawn() {
        if (!isVisible) return; // Double check
        if (activeStars.length >= maxStars) return;
        createStar();
    }

    // Initial population handled by observer or fallthrough
    // If element is already visible, observer fires immediately.
    // Explicit call removed to avoid double scheduling if observer acts fast.
};
